import { render, staticRenderFns } from "./MainJouRashodCard.vue?vue&type=template&id=3a84c8bb&scoped=true&"
import script from "./MainJouRashodCard.vue?vue&type=script&lang=js&"
export * from "./MainJouRashodCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouRashodCard.vue?vue&type=style&index=0&id=3a84c8bb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84c8bb",
  null
  
)

export default component.exports